const KEY = 'trackme.webSession';
const WEEK_MS = 7 * 24 * 60 * 60 * 1000;

const tokenExpiry = token => {
  try {
    const payload = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
    const exp = JSON.parse(atob(payload)).exp;
    return typeof exp === 'number' && Number.isFinite(exp) ? exp * 1000 : null;
  } catch { return null; }
};

export function readWebSessionCache(token) {
  try {
    const saved = JSON.parse(localStorage.getItem(KEY) || 'null');
    if (!saved || saved.token !== token || !(saved.expiresAt > Date.now()) || saved.data?.is_authenticated !== true) return null;
    return saved.data;
  } catch { return null; }
}

export function saveWebSessionCache(token, data) {
  if (data?.is_authenticated !== true) return;
  // Cache only the identity and flags used by the app shell. API permissions
  // continue to be checked by the server on every protected request.
  const cached = {
    is_authenticated: true, user: typeof data.user === 'object' ? data.user?.id : data.user ?? data.user_id,
    is_admin: !!data.is_admin, email_confirmed: !!data.email_confirmed,
    social_email_verified: !!data.social_email_verified, is_social_account: !!data.is_social_account,
    social_providers: data.social_providers,
    profile: { email: data.profile?.email ?? data.email ?? data.user?.email ?? data.user_email,
      profile_image: data.profile?.profile_image ?? data.profile_image ?? data.user?.profile_image },
  };
  try {
    localStorage.setItem(KEY, JSON.stringify({ token, data: cached, expiresAt: Math.min(tokenExpiry(token) ?? Infinity, Date.now() + WEEK_MS) }));
  } catch { /* Storage failure must not interrupt a confirmed login. */ }
}

export function clearWebSessionCache() {
  try { localStorage.removeItem(KEY); } catch {}
}
